module.exports = __webpack_public_path__ + "static/img/nav.a605069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav.png
// module id = NMl0
// module chunks = 0